import './PopularCollection.css';

import PopCol1 from '../../assets/apple/iPadAccessories/PopCol1.png';
import PopCol2 from '../../assets/apple/iPadAccessories/PopCol2.png';

export const popularCollection = [
  {
    id: 1,
    name: 'iPad Compatible Keyboard',
    image: PopCol1,
  },
  {
    id: 2,
    name: 'Edge Magic Keyboard',
    image: PopCol2,
  },
];

const PopularCollection = () => {
  return (
    <div className="popularCollection-wrapper">
      <div className="popularCollection-heading">
        <div className="popularCollection-heading-text glass-heading">
          <h2>
            iPad <strong>Accessories</strong>
          </h2>
          <h6 className="poppins-regular">✨ Check our best seller products</h6>
        </div>
      </div>
      
      <div className="popularCollection">
        <div className="popularCollection-left glass-product-card glass-bg-animated">
          <div className="pop-img-container">
            <img
              className="pop-img"
              src={PopCol1}
              alt="iPad Compatible Keyboard"
              height="auto"
              width="70%"
            />
          </div>
          <div className="pop-content">
            <p className="pop-title">
              iPad Compatible Keyboard
            </p>
            <p className="pop-price">
              Starts at <strong>₹4,999</strong>
            </p>
          </div>
        </div>
        
        <div className="popularCollection-right">
          <div className="popularCollection-right-sections glass-product-card">
            <div className="pop-img-container-small">
              <img
                className="pop-img"
                src={PopCol2}
                alt="Edge Magic Keyboard"
                height="auto"
                width="100%"
              />
            </div>
            <div className="pop-content">
              <p className="pop-title-small">
                Edge Magic Keyboard
              </p>
              <p className="pop-price-small">
                OFFER Price <strong>₹10,999</strong>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile View */}
      <div className="categories">
        <div className="category glass-card">
          <div className="category-img">
            <img src={PopCol1} alt="iPad Compatible Keyboard" />
          </div>
          <div className="category-content">
            <p className="category-title">iPad Compatible Keyboard</p>
            <p className="category-price">
              Starts at <strong>₹4,999</strong>
            </p>
          </div>
        </div>
        
        <div className="category glass-card">
          <div className="category-img">
            <img src={PopCol2} alt="Edge Magic Keyboard" />
          </div>
          <div className="category-content">
            <p className="category-title">Edge Magic Keyboard</p>
            <p className="category-price">
              OFFER Price <strong>₹10,999</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopularCollection;
